import { NavItem } from '../../nav/primitives/nav-item';
import { usePaymentsNavItem } from './use-payments-nav-item';

export const PaymentsNavItem = () => {
  const item = usePaymentsNavItem();
  return <NavItem item={item} />;
};
